module.exports = __webpack_public_path__ + "static/media/2-2-2@2x.0a5efdb2.png";